import {ResourceDto} from "../../Apis/Models/ResourceDto";
import InputLabel from "../../Components/InputLabel";
import React from "react";
import {useTranslation} from "react-i18next";
import Input from "../../Components/Input";
import FlexRow from "../../Components/FlexRow";
import {FileUploadButtonV2} from "../../Components/FileUploadButton";
import CloseIcon from "../../Assets/Icons/CloseIcon";
import Separator from "../../Components/Separator";
import {FileDto} from "../../Apis/Models/FileDto";
import {AgreementModel} from "../../Apis/Models/AgreementModel";
import {StyledText} from "../../Components/Text";

type Props = {
    agreements: AgreementModel[];
    resource: ResourceDto,
    index: number;
    updateResource: (index: number, resource: ResourceDto) => void,
    validationResult: boolean | undefined,
}
const MultipleResourceForm = ({resource, updateResource, validationResult, ...rest}: Props) => {

    const { t } = useTranslation();
    
    const updateFileName = (index, name: string) => {
        let clone = {...resource}
        
        clone.resourceFiles[index].name = name
        
        updateResource(rest.index, clone)
    }
    
    const addFile = (file: FileDto) => {
        let clone = {...resource}
        
        clone.resourceFiles.push({ id: '', name: '', file: file })
        
        updateResource(rest.index, clone)
    }
    
    const removeFile = (index: number) => {
        let clone = {...resource}
        
        clone.resourceFiles.splice(index, 1)
        
        updateResource(rest.index, clone)
    }
    
    return (
        <div className={"w-100"}>
            
            <StyledText type={"Body"} weight={"Bold"}>
                {rest.agreements.filter(x => x.id === resource.agreementIds[0])[0].companyName}

                {validationResult === false && (
                    <StyledText type={"Caption"} weight={"Bold"} color={"error"}>
                        &nbsp;- {t('resourceValidationFailedMessage')}
                    </StyledText>
                )}
            </StyledText>
            
            {resource.resourceFiles.map((file, index) => (
                <React.Fragment key={file.id}>
                    <div className={"w-100"}>
                        <InputLabel>
                            {t('fileName')}
                        </InputLabel>

                        <FlexRow justify={"space-between"}>
                            <Input name={"fileName"} onChange={(e) => updateFileName(index, e.currentTarget.value)} value={file.name} />

                            {file.file.fileName}
                            <CloseIcon onClick={() => removeFile(index)} fill={"red"} />
                        </FlexRow>
                    </div>

                    {index !== resource.resourceFiles.length - 1 && (
                        <Separator />
                    )}
                </React.Fragment>
            ))}
            
            <div style={{paddingTop: 10, paddingBottom: 30}}>
                <FileUploadButtonV2 text={t('addFile')} callback={addFile} />
            </div>

            <Separator />
        </div>
    )

}

export default MultipleResourceForm